export default {
  methods: {
    handleExternalLinks () {
      // empty function, as the modal dialog for external links should not be shown at all
    },
  },
};
